/*
 * Protección básica de las fotos (10-10-2026, petición de Daniel).
 * Bloquea el menú del clic derecho y el arrastre sobre imágenes. Es solo disuasorio:
 * no impide capturas de pantalla ni que Google indexe las fotos.
 * En el editor de temas no se activa, para no molestar al editar.
 */
(() => {
  if (window.Shopify && window.Shopify.designMode) return;
  const isImage = (target) =>
    target instanceof Element && (target.tagName === 'IMG' || target.tagName === 'PICTURE' || target.closest('picture'));
  document.addEventListener('contextmenu', (event) => {
    if (isImage(event.target)) event.preventDefault();
  });
  document.addEventListener('dragstart', (event) => {
    if (isImage(event.target)) event.preventDefault();
  });
})();
